import { render, staticRenderFns } from "./informer.vue?vue&type=template&id=1fca0dcd"
import script from "./informer.vue?vue&type=script&lang=js"
export * from "./informer.vue?vue&type=script&lang=js"
import style0 from "./informer.vue?vue&type=style&index=0&id=1fca0dcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports